import React, { Component } from 'react'
import { Button, Col, Label, Row } from 'reactstrap'
import { observer } from 'mobx-react'
import { formatNullableValue } from '../../../utils/formatar'

@observer
export default class BookingDepotCard extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    renderFields(col) {
        if(col.dataField !== this.props.titulo && col.dataField !== this.props.subtitulo){
            if(col.typeButton) {
                if(this.props.data.Associacao.DepotId !== 0) {
                    return (
                        <div className="info bg-cinza">
                            <div className="valor">
                                <Button className="px-2 btn-com-bordas-cinza" onClick={() => col.buttonOnclick(this.props.data, "Desassoc")}>Desassociar</Button>
                            </div>
                        </div>
                    )
                }else{
                    return (
                        <div className="info bg-cinza">
                            <div className="valor">
                                <Button onClick={() => col.buttonOnclick(this.props.data, "Assoc")} className="px-2 btn-com-bordas-primary">Associar</Button>
                            </div>
                        </div>
                    )
                }
            } else{
                const fields = col.dataField.split('.')
                return (
                    <div className="info bg-cinza">
                        <div className="titulo">{col.text}</div>
                        <div className="valor">
                            {formatNullableValue(this.props.data[fields[0]][fields[1]], this.props.data)}
                        </div>
                    </div>
                )
            }
        }
        return null
    }

    render() {
        return (
            <Col xs={12} md={6} lg={4} className="px-0">
                <div className={`card-navio`}>
                    <Row>

                        <Col xs={12} className="px-0">
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.data[this.props.titulo] }</Label>
                                <Label className="subtitulo">{ this.props.data[this.props.subtitulo] }</Label>
                            </div>
                        </Col>

                        {this.props.colunas.map((col, x) =>
                            (col.dataField !== this.props.titulo) &&
                            (col.dataField !== this.props.subtitulo) &&
                            <Col xs={col.text === "Anexo" ? 12 : 6} className="px-0" key={x}>
                                {this.renderFields(col)}
                            </Col>
                        )}
                    </Row>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bookingdepot/components/BookingDepotCard.js